export default __webpack_public_path__ + "static/media/driver_white.dae5ea28.svg";